import LogoSvg from 'assets/images/logo-diamond-color.svg'
import Column from 'components/Column'
import I18n from 'components/I18n'
import Row from 'components/Row'
import Text from 'components/Text'
import messages from 'lang'
import React from 'react'
import styled from 'styled-components'
import { color, zIndex } from 'utils'

const Wrapper = styled(Row)`
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: fixed;
  z-index: ${zIndex(6)};
  background-color: ${color('blackAlpha75')};
`
const Title = styled(Column)`
  position: relative;
  padding: 0 7rem 7rem;
  text-align: center;
  color: ${color('white')};
`
const Tip = styled(Text)`
  margin-bottom: 2rem;
`
const MaintenanceImg = styled.img`
  margin-bottom: 4rem;
  height: 6.5rem;
  width: auto;
`
const Link = styled.a`
  color: ${color('blue600')};
  text-decoration: none;
`

type Props = {
  code: string
}

const GeneralAlert = ({ code }: Props) => (
  <Wrapper alignItems='center' justifyContent='center'>
    <Title alignItems='center'>
      <MaintenanceImg src={LogoSvg} />
      <Tip size='lg'>
        <I18n data={messages.general_alert_1} />
      </Tip>
      <Tip>
        <I18n data={messages.general_alert_2} />
      </Tip>
      <Tip>{code}</Tip>
      <Tip>
        Get the latest updates <Link href='https://www.blockchain-status.com'>here</Link>
      </Tip>
    </Title>
  </Wrapper>
)

export default GeneralAlert
